module.exports = __webpack_public_path__ + "static/media/cq_orologio.29c1c5fe.svg";